export { default as ic_list_color } from "./ic_list_color.svg?react";
export { default as ic_list_white } from "./ic_list_white.svg?react";
export { default as ic_developement_color } from "./ic_developement_color.svg?react";
export { default as ic_developement_white } from "./ic_developement_white.svg?react";
export { default as ic_chart_color } from "./ic_chart_color.svg?react";
export { default as ic_chart_white } from "./ic_chart_white.svg?react";
export { default as ic_earth_color } from "./ic_earth_color.svg?react";
export { default as ic_earth_white } from "./ic_earth_white.svg?react";
export { default as ic_education_color } from "./ic_education_color.svg?react";
export { default as ic_education_white } from "./ic_education_white.svg?react";
export { default as ic_flask_color } from "./ic_flask_color.svg?react";
export { default as ic_flask_white } from "./ic_flask_white.svg?react";
export { default as ic_human_color } from "./ic_human_color.svg?react";
export { default as ic_human_white } from "./ic_human_white.svg?react";
export { default as ic_irRegular_color } from "./ic_irRegular_color.svg?react";
export { default as ic_irRegular_white } from "./ic_irRegular_white.svg?react";
export { default as ic_regular_color } from "./ic_regular_color.svg?react";
export { default as ic_regular_white } from "./ic_regular_white.svg?react";
export { default as ic_management_color } from "./ic_management_color.svg?react";
export { default as ic_management_white } from "./ic_management_white.svg?react";
export { default as ic_marketing_color } from "./ic_marketing_color.svg?react";
export { default as ic_marketing_white } from "./ic_marketing_white.svg?react";
export { default as ic_pencil_color } from "./ic_pencil_color.svg?react";
export { default as ic_pencil_white } from "./ic_pencil_white.svg?react";
export { default as ic_recommend_color } from "./ic_recommend_color.svg?react";
export { default as ic_recommend_white } from "./ic_recommend_white.svg?react";
export { default as ic_document_color } from "./ic_document_color.svg?react";
export { default as ic_document_white } from "./ic_document_white.svg?react";
export { default as ic_people_white } from "./ic_people_white.svg?react";
export { default as ic_people_color } from "./ic_people_color.svg?react";
export { default as icon_file_open } from "./icon_file_open.svg?react";
export { default as ic_crown } from "./ic_crown.svg?react";
export { default as ic_new_clock } from "./ic_new_clock.svg?react";
export { default as ic_member } from "./ic_member.svg?react";
